import { makeContextModule } from '@cian/react-utils';

import { type TCardContextData } from '@/microfrontends/listing/shared/types/TCardContextData';

export const {
  Context: { Provider: CardContextProvider },
  useContext: useCardContext,
} = makeContextModule<TCardContextData>({
  contextName: 'CardContext',
});
